import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const API = '/api';

const ROLES = [
  { value: 'אבא', label: 'אבא' },
  { value: 'אמא', label: 'אמא' },
  { value: 'בן', label: 'בן' },
  { value: 'בת', label: 'בת' },
  { value: 'אחר', label: 'אחר' },
];

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f0fdfa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'system-ui, sans-serif',
    direction: 'rtl',
    textAlign: 'right',
    padding: 24,
  },
  card: {
    background: '#fff',
    padding: 32,
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(15, 118, 110, 0.15)',
    width: '100%',
    maxWidth: 400,
  },
  title: { color: '#0f766e', fontSize: 24, marginBottom: 24, textAlign: 'right' },
  form: { display: 'flex', flexDirection: 'column', gap: 14 },
  input: {
    padding: 14,
    borderRadius: 8,
    border: '1px solid #e2e8f0',
    fontSize: 16,
    textAlign: 'right',
    direction: 'rtl',
  },
  label: { fontSize: 14, color: '#64748b', marginBottom: 4 },
  button: {
    background: '#0f766e',
    color: '#fff',
    border: 'none',
    padding: 14,
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 8,
  },
  buttonDisabled: { background: '#cbd5e1', color: '#94a3b8', cursor: 'not-allowed' },
  linkBtn: {
    background: 'none',
    border: 'none',
    color: '#0f766e',
    cursor: 'pointer',
    fontSize: 14,
    marginTop: 12,
    textAlign: 'right',
  },
  error: { color: '#dc2626', fontSize: 14 },
  stepTitle: { color: '#0f766e', fontSize: 16, fontWeight: 600, marginBottom: 12 },
  roleRow: { display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 },
  roleChip: {
    padding: '8px 14px',
    borderRadius: 20,
    border: '1px solid #e2e8f0',
    background: '#fff',
    cursor: 'pointer',
    fontSize: 14,
  },
  roleChipActive: { background: '#0f766e', color: '#fff', borderColor: '#0f766e' },
  termsRow: { display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 16, marginBottom: 8, cursor: 'pointer', flexDirection: 'row-reverse', justifyContent: 'flex-end' },
  checkbox: { marginLeft: 4, marginTop: 4 },
  termsLabel: { fontSize: 14, color: '#475569', textAlign: 'right' },
  termsLink: { color: '#0f766e', fontWeight: 600, textDecoration: 'none' },
};

export default function Register() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [mode, setMode] = useState(null); // 'create' | 'join'
  const [familyName, setFamilyName] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('אבא');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  const handleStep1 = (e) => {
    e.preventDefault();
    setError('');
    if (!termsAccepted) {
      setError('יש לאשר שקראת והסכמת לתנאי השימוש ומדיניות הפרטיות');
      return;
    }
    if (mode === 'create') {
      if (familyName.trim().length < 2) {
        setError('שם המשפחה חייב להכיל לפחות 2 תווים');
        return;
      }
      setStep(2);
      return;
    }
    if (mode === 'join') {
      if (!inviteCode.trim()) {
        setError('הזן קוד הזמנה');
        return;
      }
      setStep(2);
      return;
    }
    setError('בחר צור משפחה או הצטרף עם קוד');
  };

  const handleStep2 = async (e) => {
    e.preventDefault();
    setError('');
    if (!name.trim()) {
      setError('הזן את שמך');
      return;
    }
    if (!email.trim()) {
      setError('הזן אימייל');
      return;
    }
    if (!password || password.length < 6) {
      setError('הזן סיסמה (לפחות 6 תווים)');
      return;
    }
    setLoading(true);
    try {
      let familyId;
      if (mode === 'create') {
        const res = await fetch(API + '/families', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: familyName }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'יצירת משפחה נכשלה');
        familyId = data.id;
      } else {
        const res = await fetch(API + '/families/join?code=' + encodeURIComponent(inviteCode.trim().toUpperCase()));
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'קוד לא תקין');
        familyId = data.id;
      }
      const res = await fetch(API + '/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          familyId,
          inviteCode: mode === 'join' ? inviteCode.trim().toUpperCase() : undefined,
          name: name.trim(),
          role,
          email: email.trim(),
          phone: phone.trim() || undefined,
          password,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'הרשמה נכשלה');
      navigate('/login', { state: { message: 'נרשמת בהצלחה. התחבר עם האימייל והסיסמה.' } });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (step === 1) {
    return (
      <div className="nasati-page" style={styles.page}>
        <div className="nasati-card" style={styles.card}>
          <h1 style={styles.title}>הרשמה — שלב 1</h1>
          <p style={styles.stepTitle}>צור משפחה חדשה או הצטרף עם קוד</p>
          <form onSubmit={handleStep1} style={styles.form}>
            <div>
              <button
                type="button"
                style={{ ...styles.button, background: mode === 'create' ? '#0f766e' : '#e2e8f0', color: mode === 'create' ? '#fff' : '#64748b', marginBottom: 8 }}
                onClick={() => { setMode('create'); setError(''); }}
              >
                צור משפחה חדשה
              </button>
              {mode === 'create' && (
                <input
                  type="text"
                  placeholder="שם המשפחה (לפחות 2 תווים)"
                  value={familyName}
                  onChange={(e) => setFamilyName(e.target.value)}
                  className="nasati-input"
                  style={styles.input}
                  minLength={2}
                />
              )}
            </div>
            <div>
              <button
                type="button"
                style={{ ...styles.button, background: mode === 'join' ? '#0f766e' : '#e2e8f0', color: mode === 'join' ? '#fff' : '#64748b' }}
                onClick={() => { setMode('join'); setError(''); }}
              >
                הצטרף עם קוד הזמנה
              </button>
              {mode === 'join' && (
                <input
                  type="text"
                  placeholder="קוד הזמנה (6 תווים)"
                  value={inviteCode}
                  onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
                  className="nasati-input"
                  style={styles.input}
                  maxLength={6}
                />
              )}
            </div>
            <label style={styles.termsRow}>
              <input
                type="checkbox"
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
                style={styles.checkbox}
              />
              <span style={styles.termsLabel}>
                קראתי, הבנתי ומסכימ/ה ל
                <Link to="/terms" target="_blank" rel="noopener noreferrer" style={styles.termsLink}>תנאי השימוש ומדיניות הפרטיות</Link>
              </span>
            </label>
            {error && <p style={styles.error}>{error}</p>}
            <button
              type="submit"
              className="nasati-button"
              style={{ ...styles.button, ...(!termsAccepted || (mode === 'create' && familyName.trim().length < 2) ? styles.buttonDisabled : {}) }}
              disabled={!termsAccepted || (mode === 'create' && familyName.trim().length < 2)}
            >
              המשך
            </button>
          </form>
          <button type="button" style={styles.linkBtn} onClick={() => navigate('/')}>
            חזרה לדף הבית
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="nasati-page" style={styles.page}>
      <div className="nasati-card" style={styles.card}>
        <h1 className="nasati-title" style={styles.title}>הרשמה — שלב 2</h1>
        <p style={styles.stepTitle}>פרטיך בקבוצה</p>
        <form className="nasati-form" onSubmit={handleStep2} style={styles.form}>
          <div>
            <label style={styles.label}>שם מלא</label>
            <input
              type="text"
              placeholder="השם שלך"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="nasati-input"
              style={styles.input}
              required
            />
          </div>
          <div>
            <label style={styles.label}>תפקיד</label>
            <div style={styles.roleRow}>
              {ROLES.map((r) => (
                <button
                  key={r.value}
                  type="button"
                  style={{ ...styles.roleChip, ...(role === r.value ? styles.roleChipActive : {}) }}
                  onClick={() => setRole(r.value)}
                >
                  {r.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <label style={styles.label}>אימייל (לכניסה לאתר)</label>
            <input
              type="email"
              placeholder="אימייל"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="nasati-input"
              style={styles.input}
              required
            />
          </div>
          <div>
            <label style={styles.label}>טלפון (אופציונלי)</label>
            <input
              type="tel"
              placeholder="טלפון"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="nasati-input"
              style={styles.input}
            />
          </div>
          <div>
            <label style={styles.label}>סיסמה (לפחות 6 תווים)</label>
            <input
              type="password"
              placeholder="סיסמה"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="nasati-input"
              style={styles.input}
              minLength={6}
              required
            />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" className="nasati-button" style={styles.button} disabled={loading}>
            {loading ? 'מרשם...' : 'סיום הרשמה'}
          </button>
        </form>
        <button type="button" style={styles.linkBtn} onClick={() => setStep(1)}>
          חזרה
        </button>
      </div>
    </div>
  );
}
